import React from "react";

export default function Spinner() {
    return <div className="itf-spinner" role="status" aria-hidden="true"></div>;
}
